import React from 'react'

function Guidance() {
  return (
    <div className='Container font-weight-bold h4 justify-content-center'>
       <h1 className="font-wight-light mx-auto">
           <span className="text-info">
           Guidelines 
           </span> To User Our website
           <br />      Thanks You for visiting our website.
       </h1>
        <div className="d-flex p-2 justify-content-center">
      
  
    <br />
      
        Registration is not required for using Blogs and Compiler sections.It Means user can read and perform the labs without registration.
      <br />
      for community,Add Projects,Write-a-recommendations Registration is mandatory.
        </div>
  
      </div>
  )
}

export default Guidance
